export const GROUPS = [
    {
        "id_group_type": 1,
        "group_type_name": "group-type-love",
        "color": "df64b8"
    },
    {
        "id_group_type": 2,
        "group_type_name": "group-type-friends",
        "color": "fae087"
    },
    {
        "id_group_type": 3,
        "group_type_name": "group-type-colleagues",
        "color": "7c98f5"
    },
    {
        "id_group_type": 4,
        "group_type_name": "group-type-family",
        "color": "f5a682"
    },
    {
        "id_group_type": 5,
        "group_type_name": "group-type-celebrities",
        "color": "7AE0D9"
    },
    {
        "id_group_type": 6,
        "group_type_name": "group-type-rival",
        "color": "d772ff"
    },
];